import React, { useEffect, useState } from 'react';
import { SingleCollapse, MasterDataGrid } from "@/components/";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import FollowupSubProjectPresenter from "../../../../presenters/screens/followup-subproject.presenter";
import { Utilities } from "@utils";
import FinancialResults from './results';
import styles from './index.module.scss';
interface IFinancialExpectedResultsProps{
    summaryData: any;
    screen: string;
    columns: any[];
    saveTable: any;
    summary: any;
    sectionData: any[];
    status: any;
    tableAlert: string;
    dataColumns: any;
    initialValidate: boolean;
    section: string;
    year: number
}

const FinancialExpectedResults: React.FC<IFinancialExpectedResultsProps> = ({initialValidate, summaryData, screen, columns, saveTable, tableAlert, 
    summary, sectionData, status, dataColumns, section, year}: IFinancialExpectedResultsProps) => {

    const [totalSummary, setTotalSummary] = useState(null);
    const [results, setResults] = useState(null);

    const view: IFollowupSubproject = {
        state: {
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    useEffect(() => {
        if(sectionData?.length) getResults(sectionData)
    }, [sectionData, tableAlert, screen, initialValidate, presenter.stepTourFin]);

    useEffect(() => {
        if(summaryData?.length) getTotalSummaries(summaryData)
    }, [summaryData]);

    const getTotalSummaries = (data: any) => {
        let auxCol = Utilities.copyObject(columns)
            auxCol = auxCol.filter((col: any) => {
                if(col.dataField !== "activity"){
                    if(col?.columns?.length){
                        for (const childCol of col.columns) {
                            childCol.allowEditing = false
                        }
                    }
                    col.allowEditing = false
                    return col
                }
            })
        setTotalSummary(
            <MasterDataGrid 
                id={`totalResults`}
                dataSource={data}
                columns={auxCol}
                allowCode={screen}
                saveTable={saveTable}
                gridTitle={presenter.followupLabels.get("financialTotalResultsTitle")}
                gridHelpId={`tooltip-Total-Resultados`}
                gridHelpText={presenter.followupLabels.get("helpFinancialTotalResults")}
                gridProps={{
                    width: "100%",
                    scrolling:{mode: "standard", rowRenderingMode: "standard"},
                    editing:{ mode: "batch", allowUpdating: true, allowAdding: false, allowDeleting: false},
                    summary: {
                        recalculateWhileEditing: true,
                        totalItems: summary.totalItems,
                        calculateCustomSummary: (options) => summary.calculateCustomSummary(options)
                    },
                    onContentReady: (data) => {
                        if(data.component !== undefined){
                            const element = data.component.element();
                            const totals = element.querySelector(".dx-datagrid-total-footer div:last-child tbody tr") as HTMLElement;
                            const totalHeader = element.querySelector(".dx-datagrid-total-footer table tbody tr") as HTMLElement;
                
                            if(totals !== null){
                                totals.childNodes.forEach((childNode: any) => {
                                    childNode.style.borderColor = "rgba(0,0,0,0.1)";
                                    childNode.style.backgroundColor = "rgba(255,240,230,0.8)";
                                })
                            }
                            if(totalHeader !== null){
                                totalHeader.childNodes.forEach((childNode: any) => {
                                    childNode.style.borderColor = "rgba(0,0,0,0.1)";
                                    childNode.style.backgroundColor = "rgba(255,240,230,0.8)";
                                })
                            }
                        }
                    }
                }}
            />
        );
    }

    const getResults = (data:any) => {
        const res = data.map((result: any, idx: number) => {
            return (
                <SingleCollapse 
                    keepOpen={!!tableAlert}
                    title={result.staticTitle}
                    description={result.name}
                    isOpen={(tableAlert === "All" || initialValidate || (presenter.stepTourFin >= 3 && idx === 0)) ? true : false}
                    key={`${result.id}-actResult`}
                    idIcon={(idx === 0 && presenter.stepTourFin >= 3) ? "FinancialTourStep4" : '' } 
                >
                    <FinancialResults 
                        section={section}
                        initialValidate={initialValidate}
                        dataColumns={dataColumns}
                        idx={idx} 
                        result={result}
                        screen={screen}
                        columns={columns}
                        saveTable={saveTable}
                        summary={summary}
                        status={status}
                        tableAlert={tableAlert}
                        year={year}
                    />
                </SingleCollapse>
            );            
        });
        setResults(res)
    }

    return (
        <div className={styles.divPpal}>
            <SingleCollapse
                keepOpen={!!tableAlert}
                idIcon="FinancialTourStep3"
                title={presenter.followupLabels.get("financialBudgetByActivity")}
                isOpen={(tableAlert === "All" || initialValidate || presenter.stepTourFin >= 3) ? true : false} 
            >
                {(results && totalSummary) ?
                    <>
                        {results}
                        {totalSummary}
                    </>
                    :   <div><h6 style={{color:"rgb(240, 53, 0)"}}>{presenter.followupLabels.get("noInformationAvailable")}</h6></div>
                }
            </SingleCollapse>
        </div>
    )
}

export default FinancialExpectedResults;